/**
 * Sistema de Abas de Coleções
 * Controla a navegação, exibição das abas e carousel mobile
 */

class AbaColecoes {
  constructor() {
    this.container = document.querySelector('.aba-colecoes-section');
    this.tabs = document.querySelectorAll('.aba-colecoes-tab');
    this.contents = document.querySelectorAll('.aba-colecoes-produtos');
    this.swipers = {};
    this.mobileBreakpoint = 768;

    this.init();
  }

  init() {
    if (!this.container || !this.tabs.length || !this.contents.length) {
      return;
    }

    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => this.handleTabClick(e));
    });

    this.setActiveTab(0);
    this.initMobileSwipers();

    window.addEventListener('resize', () => this.handleResize());
  }

  handleTabClick(event) {
    event.preventDefault();
    const clickedTab = event.currentTarget;
    const tabIndex = parseInt(clickedTab.getAttribute('data-tab-index'));
    this.setActiveTab(tabIndex);
  }

  setActiveTab(index) {
    this.tabs.forEach(tab => tab.classList.remove('active'));
    this.contents.forEach(content => content.classList.remove('active'));

    if (this.tabs[index]) {
      this.tabs[index].classList.add('active');
    }

    if (this.contents[index]) {
      this.contents[index].classList.add('active');
    }

    // Atualizar swiper da aba ativa (necessário para corrigir layout)
    if (this.swipers[index] && window.innerWidth <= this.mobileBreakpoint) {
      setTimeout(() => {
        this.swipers[index].update();
      }, 50);
    }

    this.dispatchTabChangeEvent(index);
  }

  initMobileSwipers() {
    if (window.innerWidth > this.mobileBreakpoint) return;
    if (typeof Swiper === 'undefined') return;

    const swiperEls = this.container.querySelectorAll('.produtos-swiper-mobile');
    swiperEls.forEach(el => {
      const tabIndex = el.getAttribute('data-tab-swiper');
      if (this.swipers[tabIndex]) return;

      this.swipers[tabIndex] = new Swiper(el, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        watchOverflow: true,
        breakpoints: {
          480: {
            slidesPerView: 1.5,
            spaceBetween: 16,
          }
        }
      });
    });
  }

  destroySwipers() {
    Object.keys(this.swipers).forEach(key => {
      if (this.swipers[key] && this.swipers[key].destroy) {
        this.swipers[key].destroy(true, true);
      }
    });
    this.swipers = {};
  }

  handleResize() {
    if (window.innerWidth <= this.mobileBreakpoint) {
      if (Object.keys(this.swipers).length === 0) {
        this.initMobileSwipers();
      }
    } else {
      if (Object.keys(this.swipers).length > 0) {
        this.destroySwipers();
      }
    }
  }

  dispatchTabChangeEvent(index) {
    if (this.container) {
      const event = new CustomEvent('abaColecaoChange', {
        detail: {
          tabIndex: index,
          tab: this.tabs[index],
          content: this.contents[index]
        }
      });
      this.container.dispatchEvent(event);
    }
  }

  changeTab(index) {
    if (index >= 0 && index < this.tabs.length) {
      this.setActiveTab(index);
    }
  }

  getActiveTab() {
    return Array.from(this.tabs).findIndex(tab =>
      tab.classList.contains('active')
    );
  }
}

// Inicializar quando o DOM estiver carregado
document.addEventListener('DOMContentLoaded', function() {
  new AbaColecoes();
});

// Reinicializar se necessário (por exemplo, após AJAX)
if (typeof window !== 'undefined') {
  window.initAbaColecoes = function() {
    new AbaColecoes();
  };
}

// Suporte para teclado (acessibilidade)
document.addEventListener('keydown', function(event) {
  const activeTab = document.querySelector('.aba-colecoes-tab.active');

  if (!activeTab) return;

  let newIndex = -1;
  const currentIndex = parseInt(activeTab.getAttribute('data-tab-index'));
  const totalTabs = document.querySelectorAll('.aba-colecoes-tab').length;

  switch(event.key) {
    case 'ArrowLeft':
      newIndex = currentIndex > 0 ? currentIndex - 1 : totalTabs - 1;
      break;
    case 'ArrowRight':
      newIndex = currentIndex < totalTabs - 1 ? currentIndex + 1 : 0;
      break;
    case 'Home':
      newIndex = 0;
      break;
    case 'End':
      newIndex = totalTabs - 1;
      break;
  }

  if (newIndex !== -1) {
    event.preventDefault();
    const newTab = document.querySelector(`[data-tab-index="${newIndex}"]`);
    if (newTab && typeof newTab.click === 'function') {
      newTab.click();
      if (typeof newTab.focus === 'function') {
        newTab.focus();
      }
    }
  }
});
